export default function Richtingen() {
	return <div>Richtingen</div>;
}
